import Vue from 'vue'
import Vuex from "vuex";
import session from './modules/session'
import user from './modules/user'
import cart from './modules/cart'
import products from './modules/products'
import coverage from './modules/coverage-map'
import createLogger from './plugins/logger'

Vue.use(Vuex)

const debug = false;//process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
      session,
      user,
      cart,
      products,
      coverage
    },
    strict: debug,
    plugins: debug ? [createLogger()] : []
})
